import type { GeneralAdviceForm } from '@feh/standalone-forms-models';
import type {
  LeadContextRequestTypeSchema,
  PostAdviceV1Data,
  PostProductadviceV1Data,
} from '@integration/api-client/feh';

export function mapFormToPostAdviceV1Data(
  formData: GeneralAdviceForm['value'],
  scContext: {
    productType: string;
    channel: string;
    subChannel?: string;
    campaignName?: string;
  },
  brand: 'energiedirect' | 'essent',
  url: string,
  e2eTrackingId: string
): PostAdviceV1Data {
  return {
    requestBody: {
      type: 'advice',
      context: mapContext(scContext, brand, url),
      lead: mapLead(formData),
      consent: {
        dataUsage: formData.allowDataUsage,
        promotion: formData.allowPromotionalUpdates,
      },
      metadata: {
        temperature: 4,
        createdOn: new Date().toISOString(),
        remarks: mapRemarks(formData.remarks, formData.insulationType),
        adobeId: e2eTrackingId,
      },
    },
  };
}

export function mapFormToPostProductadviceV1Data(
  formData: GeneralAdviceForm['value'],
  scContext: {
    productType: string;
    channel: string;
    subChannel?: string;
    campaignName?: string;
  },
  brand: 'energiedirect' | 'essent',
  url: string,
  e2eTrackingId: string
): PostProductadviceV1Data {
  return {
    requestBody: {
      type: 'productAdvice',
      context: mapContext(scContext, brand, url),
      lead: mapLead(formData),
      consent: {
        dataUsage: formData.allowDataUsage,
        promotion: formData.allowPromotionalUpdates,
      },
      metadata: {
        temperature: 4,
        createdOn: new Date().toISOString(),
        remarks: mapRemarks(formData.remarks, formData.insulationType),
        adobeId: e2eTrackingId,
        reference: {},
      },
      products: [
        {
          category: scContext.productType,
        },
      ],
    },
  };
}

function mapLead(formData: GeneralAdviceForm['value']) {
  const { address, name } = formData;

  return {
    title: formData.title as string,
    initials: name?.initials as string,
    prefix: name?.insertion,
    lastName: name?.lastName as string,
    addresses: address
      ? {
          communication: {
            postcode: address?.postcode as string,
            street: address?.street as string,
            houseNumber: address?.houseNumber?.toString() as string,
            houseNumberExtension:
              address?.houseNumberAddition?.trim() || undefined,
            city: address?.city as string,
          },
        }
      : undefined,
    phone: formData.phone as string,
    email: formData.email as string,
    companyName: formData.companyName || undefined,
  };
}

function mapContext(
  scContext: {
    productType: string;
    channel: string;
    subChannel?: string;
    campaignName?: string;
  },
  brand: 'energiedirect' | 'essent',
  url: string
) {
  return {
    channel: scContext.channel,
    subChannel: scContext.subChannel,
    brand,
    campaignName: scContext.campaignName,
    productType: scContext.productType,
    requestType: 'Advies' as LeadContextRequestTypeSchema,
    website: url,
  };
}

function mapRemarks(remarks = '', insulationType?: string) {
  if (insulationType) {
    return `Opmerking: ${remarks === '' ? '-' : remarks}\nSoort isolatie: ${insulationType}`;
  } else {
    return remarks === '' ? undefined : remarks;
  }
}
